import { APP_INITIALIZER, NgModule } from '@angular/core';  // MR 01DEC24 Docker Compose Changes
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HrmComponent } from './pages/hrm/hrm.component';

import { PopoverComponent } from './components/popover/popover.component';

import { AuthGuard } from './services/auth.guard';
import { ApiInterceptorService } from './services/api-interceptor.service';
import { SideNavEmitService } from './services/side-nav-emit.service';
import { SuccessFailureMessageComponent } from './components/alert-message/success-failure-message.component';
import { NgxPaginationModule } from 'ngx-pagination';

// for my changes
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropFilesDirective } from './directives/drag-drop-files/drag-drop-files.directive';
import { TruncateNamePipe } from './pipes/truncateName/truncate-name.pipe';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { AmountToWordsPipe } from './pipes/amount-to-words.pipe';
import { AttendanceColorDirective } from './directives/attendance-color/attendance-color.directive';
import { NbCardModule, NbThemeModule } from '@nebular/theme';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartModule } from 'angular2-chartjs';
import { NxtAppModule } from '@rangertechnologies/ngnxt';
import { NgxSpinnerModule } from 'ngx-spinner'; //SK15JUL24 importing spinner module
import { EmailPopupComponent } from './components/email-popup/email-popup.component';  // SKS24AUG24 importing email popup component

// MR 01DEC24 Docker Compose Changes
import { ConfigService } from 'src/app/services/config.service';
export const configFactory = (configService: ConfigService) => {
  return () => configService.loadConfig();
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AngularSvgIconModule.forRoot(),
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    PopoverComponent,
    SuccessFailureMessageComponent,
    NgxPaginationModule,
    BrowserAnimationsModule,
    MatInputModule,
    DragDropFilesDirective,
    TruncateNamePipe,
    CurrencyPipe,
    AttendanceColorDirective,
    NbThemeModule.forRoot({ name: 'default' }),
    NgxChartsModule,
    NbCardModule,
    ChartModule,
    NbCardModule,
    NxtAppModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    EmailPopupComponent
  ],
  exports: [AngularSvgIconModule],
  providers: [
    {provide: HTTP_INTERCEPTORS,useClass: ApiInterceptorService,multi: true},
    {provide: APP_INITIALIZER, useFactory: configFactory, deps: [ConfigService], multi: true},
    SideNavEmitService,
    AuthGuard,
    CurrencyPipe,
    AmountToWordsPipe,
    HrmComponent,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
